"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bitNotDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var bitNotDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createBitNot: _factoriesAny.createBitNot
};
exports.bitNotDependencies = bitNotDependencies;